import { queryOptions } from "@tanstack/react-query";
import { homeKeys } from "../constants/query-keys";
import { homeApi } from "./home.api";

export const homeQueryOptions = (lang?: string) =>
  queryOptions({
    queryKey: homeKeys.data(lang),
    queryFn: () => homeApi.get(lang),
    staleTime: 60_000,
  });
